'use client';
import { createStyles, xref, rem } from '@s7/styles';
import { getViewSpec } from './style.strategies.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var useStyles = createStyles(function(theme, param, param1) {
    var color = param.color, transitionDuration = param.transitionDuration;
    var variant = param1.variant;
    var _theme_fn = theme.fn, focusRing = _theme_fn.focusRing, transition = _theme_fn.transition;
    var shades = getViewSpec(theme, variant, color);
    var coloredXRef = xref("colored");
    var coloredXClass = "." + coloredXRef;
    var _obj;
    return {
        root: _extends({
            boxSizing: "border-box",
            position: "relative",
            userSelect: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: rem(3)
        }, focusRing({
            color: shades.focus
        }), (_obj = {}, _obj[coloredXClass] = _extends({
            color: shades.default
        }, transition({
            fn: "ease-in-out",
            props: [
                "color"
            ],
            duration: transitionDuration
        })), _obj["&:hover " + coloredXClass] = {
            color: shades.hover
        }, _obj["&:active " + coloredXClass] = {
            color: shades.active
        }, _obj["&:disabled,&[data-disabled=true] " + coloredXClass] = {
            color: shades.disabled,
            pointerEvents: "none"
        }, _obj["&[data-loading=true] " + coloredXClass] = {
            pointerEvents: "none"
        }, _obj["&[data-loading=true],&[data-disabled=true]"] = {
            pointerEvents: "none"
        }, _obj)),
        label: {},
        labelColor: {
            ref: coloredXRef
        },
        icon: {
            ref: coloredXRef
        },
        leftIcon: {},
        rightIcon: {}
    };
});

export { useStyles as default };
